// extracted by mini-css-extract-plugin
export default {"breadcrumb":"Breadcrumb_breadcrumb__CWFjl","link":"Breadcrumb_link__Q8uUV","divider":"Breadcrumb_divider__ARUkd","last":"Breadcrumb_last__xCdVU"};